interface Props {
  coupon?: string;
  isApplicable?: boolean;
  potentialDiscount?: number;
  finalAmount?: number;
  couponInfo?: {
    title?: string;
    info?: string;
    discountType?: string;
    discountValue?: number;
  };
}

const defaultData: Props = {
  coupon: "",
  isApplicable: false,
  potentialDiscount: undefined,
  finalAmount: undefined,
  couponInfo: undefined,
};

export class ApplyCouponModel {
  coupon?: string;
  isApplicable?: boolean;
  potentialDiscount?: number;
  finalAmount?: number;
  couponInfo?: {
    title?: string;
    info?: string;
    discountType?: string;
    discountValue?: number;
  };

  constructor(data: Props = defaultData) {
    this.coupon = data.coupon || "";
    this.isApplicable = data.isApplicable || false;
    this.potentialDiscount = data.potentialDiscount || undefined;
    this.finalAmount = data.finalAmount || undefined;
    this.couponInfo = data.couponInfo || undefined;
  }
}
